import stl from "./YearsTags.module.css";
import { useLocation, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import YearsTag from "./YearsTag/YearsTag";
import SearchArrowSVG from "./YearsTag/SVGIcons/SearchArrowSVG";
import { useLang } from "@/common/Contexts/LanguageContext";
import { generateYearsRangeList } from "@/utils/GlobalJavascriptFunction";
import {useTranslation} from "@i18n";
import useHelpers from "@hooks/useHelpers";

const YearsTags = ({
  className,
  selectedOptions,
  metaData
}) => {
  const { t } = useTranslation();
  const lang = useLang();
  const {createUrl} = useHelpers();

  const { make } = useParams();
  const location = useLocation();
  const scrollRef = useRef(null);
  const parentRef = useRef(null);
  const anchor1 = useRef(null);
  const anchor2 = useRef(null);
  const scrollAmount = 600;
  const [Iscroll, setIscroll] = useState(false);
  const [IsLast, setIsLast] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (scrollRef.current) {
        setTimeout(() => {
          checkWrapperShift();
        }, 310);
      }
    };

    if (scrollRef.current) {
      scrollRef.current.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (scrollRef.current) {
        scrollRef.current.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  const scroll = (dir, shift) => {
    if (dir === "left" && scrollRef.current) {
      scrollRef.current.scrollLeft -= shift;
    } else if (dir === "right" && scrollRef.current) {
      scrollRef.current.scrollLeft += shift;
    }
  };

  const checkWrapperShift = () => {
    if (lang === "ar") {
      if (
        anchor1.current?.getBoundingClientRect()?.left >
        parentRef.current?.getBoundingClientRect()?.right
      ) {
        setIscroll(true);
      } else {
        setIscroll(false);
      }

      if (
        anchor2.current?.getBoundingClientRect()?.left >
        parentRef.current?.getBoundingClientRect()?.left
      ) {
        setIsLast(true);
      } else {
        setIsLast(false);
      }
    } else {
      if (
        anchor1.current?.getBoundingClientRect()?.right <
        parentRef.current?.getBoundingClientRect()?.left
      ) {
        setIscroll(true);
      } else {
        setIscroll(false);
      }

      if (
        anchor2.current?.getBoundingClientRect()?.right <
        parentRef.current?.getBoundingClientRect()?.right
      ) {
        setIsLast(true);
      } else {
        setIsLast(false);
      }
    }
  };

  const createData = () => {
    const selectedYear = selectedOptions.find(
      (tag) => tag.filterField === "year"
    );

    if (selectedYear) {
      const makes = metaData?.seoData?.makes;

      return { tags: makes, title: t("اختر الماركة", { ns: "web_search" }) };
    }

    return {
      tags: generateYearsRangeList(),
      title: t("اختر سنة الصنع", { ns: "web_search" }),
    };
  };

  const data = createData();

  const createLink = (tag) => {
    const selectedYear = selectedOptions.find(
      (tag) => tag.filterField === "year"
    );

    if (selectedYear) {
      return createUrl(
        `${location.pathname
          .replace("/en", "")
          .slugify()}/${tag.name_en?.slugify()}`
      );
    }

    return createUrl(`/years/${tag}`);
  };

  if (make) return null;
  if (!data?.tags) return null;
  return (
    <div className={`${stl.wrapper} ${className || ""}`}>
      <strong className={`${stl.title} m-hide`}>
        {data.title}
      </strong>
      <div
        ref={parentRef}
        className={[
          stl.parentWrapper,
          Iscroll ? stl.shiftStyle : undefined,
          IsLast ? stl.lastScroll : undefined,
        ].join(" ")}>
        {data?.tags.length > 18 && (
          <SearchArrowSVG
            className={stl.leftArr}
            onClick={() => {
              scroll("left", scrollAmount);
            }}
          />
        )}
        <div className={stl.tagsWrapper} ref={scrollRef}>
          <span className={stl.anchor} ref={anchor1}></span>
          {data?.tags?.map((tag, i) => {
            return (
              <YearsTag
                title={tag.name || tag}
                key={i}
                url={createLink(tag)}
              />
            );
          })}
          <span className={stl.anchor} ref={anchor2}></span>
        </div>
        {data?.tags.length > 18 && (
          <SearchArrowSVG
            className={stl.rightArr}
            onClick={() => {
              scroll("right", scrollAmount);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default YearsTags;
